import ShopSettingDTO from "@/dto/shop/ShopSettingDTO";
import { appendExtraWaybillNoToSellerRemarks, ShopAdvancedSettingDto } from "@/services/api/shop";
import { useGlobalStore } from "@/store/hooks";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import { useRequest } from "ahooks";
import { Checkbox, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { PopoverText } from "@/components";

interface PrintingSettingProps {
    shopSetting: ShopSettingDTO;
    shopAdvancedSetting: ShopAdvancedSettingDto;
}

const PrintingSetting: React.FC<PrintingSettingProps> = function (props) {
    const { shopSetting, shopAdvancedSetting } = props;
    const { id: shopId } = shopSetting;
    const { shopAdvancedSettingStore } = useGlobalStore();
    const [appendExtraWaybillNo2SellerRemarks, updateAppendExtraWaybillNo2SellerRemarks] = useState(
        shopAdvancedSetting.appendExtraWaybillNoToSellerRemarks,
    );

    const { runAsync: saveAppendExtraWaybillNoToSellerRemarks, loading } = useRequest(
        async (enabled) => {
            const setting = await appendExtraWaybillNoToSellerRemarks(shopId, enabled);

            shopAdvancedSettingStore.setAdvancedSetting(shopId, setting);

            updateAppendExtraWaybillNo2SellerRemarks(enabled);
        },
        {
            manual: true,
        },
    );

    async function handleAppendExtraWaybillNoToSellerRemarksChange(e) {
        const enabled = e.target.checked;

        await saveAppendExtraWaybillNoToSellerRemarks(enabled);
    }

    return (
        <Spin spinning={loading}>
            <Checkbox
                checked={appendExtraWaybillNo2SellerRemarks}
                onChange={handleAppendExtraWaybillNoToSellerRemarksChange}
            >
                <PopoverText
                    content="订单只有1个运单号不会添加到卖家备注，订单有多个单号时开始追加到备注,注：备注最多支持500个字符，超过500个字符时会被截断可能备注不全"
                    getPopupContainer={(current) => current}
                >
                    {SupplierShopTypes.includes(shopSetting.type)
                        ? "打印多个单号自动追加到代发备注"
                        : "打印多个单号自动追加到备注"}
                </PopoverText>
            </Checkbox>
        </Spin>
    );
};

export default observer(PrintingSetting);
